import PageHeardImg from './PageHeard.png';
import EmptyImg from './Empty.png';
import EmptySetting from './EmptySetting.png';
import CourseDefault from './CourseDefault.png';
import ProgramDefault from './ProgramDefault.png';
import BlockEmpty from './BlockEmpty.png';
import NavMicro from './NavMicro.png';
import NavProgram from './NavProgram.png'
import NavCourse from './NavCourse.png';
import EmptySource from './EmptySource.png';
import LogoUmu from './LogoUmu.png';
import EmptyDefaultImg from './EmptyImg.png';
export const CustomImg = {
    NavProgram,
    NavMicro,
    NavCourse,
    EmptyImg,
    BlockEmpty,
    LogoUmu,
    EmptyDefaultImg,
    EmptySource,
    PageHeardImg,
    EmptySetting,
    CourseDefault,
    ProgramDefault
}
